'use client';

import H5AudioPlayer from "react-h5-audio-player";
import 'react-h5-audio-player/lib/styles.css';
import Image from "next/image";


export default function AudioPlayer({imageSrc, title, audioSrc, loop = true}: {
    imageSrc?: string,
    title: string,
    audioSrc: string,
    loop?: boolean
}) {

    const Header = () => (
        <header className="flex flex-col sm:flex-row gap-4 items-center">
            <figure className="my-0!">{imageSrc &&
                <Image quality={100} className="my-0! sm:max-w-[200px] object-cover" src={imageSrc} alt="" width={200}
                       height={100}/>}</figure>
            {title && <p className="my-0!">{title}</p>}
        </header>
    )

    return (
        <>
            <H5AudioPlayer src={audioSrc} loop={loop} header={<Header/>}/>
        </>
    );
}